/* Component search filters reducer */
import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';

export interface ISearchFiltersResearchComponentsState {
    searchTerm: string;
    componentId: any;
    dateRange: string;
    fromDate: string;
    toDate: string;
}

const defaultDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_YEARS; // but api is slow at this setting
// const defaultDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_MONTHS; // reenabled the above at rob's request.
const initialState: ISearchFiltersResearchComponentsState = {
    searchTerm: '',
    componentId: undefined,
    dateRange: defaultDateRangeValue,
    fromDate: DateRanges.getStartDate(defaultDateRangeValue),
    toDate: DateRanges.getEndDate(defaultDateRangeValue),
};

export function searchFiltersResearchComponentsReducer(state: ISearchFiltersResearchComponentsState = initialState, action: any): ISearchFiltersResearchComponentsState {
    switch (action.type) {
        case Actions.SEARCH_COMPONENTS_SEARCH_TERM:
            return _.merge({}, state, { searchTerm: action.searchTerm });
        case Actions.SEARCH_COMPONENTS_COMPONENT_ID:
            return _.merge({}, state, { componentId: action.componentId });
        case Actions.SEARCH_COMPONENTS_FROM_DATE:
            return _.merge({}, state, { fromDate: action.fromDate });
        case Actions.SEARCH_COMPONENTS_TO_DATE:
            return _.merge({}, state, { toDate: action.toDate });
        case Actions.SEARCH_COMPONENTS_DATE_RANGE:
            return _.merge({}, state, {
                dateRange: action.dateRange,
                fromDate: DateRanges.getStartDate(action.dateRange),
                toDate: DateRanges.getEndDate(action.dateRange),
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersResearchComponentsReducer.tsx